<template>
  <v-container class="dark">
    <v-row>
      <v-container>
      <v-btn
        :ripple="false"
        :elevation="0"
        class="
          font-weight-bold
          text-xs text-dark
          btn-light
          py-5
          px-6
          mt-6
          mb-2
          ms-2
        "
        @click="apiSetSeedData"
      >
        Generate seeds with AI
      </v-btn>
      </v-container>
      <v-container>
        <div v-if="seedsLoading">
          <v-progress-circular indeterminate></v-progress-circular>
        </div> 
        <v-chip class="my-1 mx-1" close color="blue" v-for="item in this.seeds" :key="item" @click:close="removeSeed(item)">
         {{ item }}
        </v-chip>
      </v-container>
      <v-container>
        <v-col cols=5>
          <h6 class="text-h6">Number of seeds: {{ this.seeds.length }}</h6>
          <br/>
          <v-text-field id="seed-input" v-model="tmpSeed" label="Add seed manually"></v-text-field>
        </v-col>
        <v-btn
          :disabled="!!!tmpSeed"
          elevation="2"
          icon
          large
          rounded
          @click="createSeed()"
        ><v-icon>mdi-checkbox-marked-circle</v-icon></v-btn>
      </v-container>
    </v-row>
  </v-container>
</template>
<script>
export default {
  name: "splash",
  props: {
    promptData: {
      type: Object,
      required: true
    },
    seeds: {
      type: Array,
      default: () => [],
      required: true
    }
  },
  data() {
    return {
      // baseApiUrl: "https://pbzsm7cftb.execute-api.us-east-2.amazonaws.com/dev",
      seedsDataList: [],
      seedsLoading: false,
      tmpSeed: '',
    }
  },
  /*mounted() {
    this.apiSetSeedData();
  },*/
  
  methods: {
    navigateToSignup() {
      this.$router.push("/sign-up-stepper");
    },
    
    apiSetSeedData() {
        this.seedsLoading = true;
        this.apiGetSeeds(this.promptData)
        .then((data) => {
          let seeds = JSON.parse(data);
          seeds = [...this.seeds, ...seeds];
          this.$emit("seedUpdate", seeds);
          this.seedsLoading = false;
          }).catch ((error) => {
          this.consoleLog('error', 'SeedsGet.vue fn(apiSetSeedData): error catch', error)
        })
    },
    
    createSeed() {
      if(this.seeds.indexOf(this.tmpSeed) != -1)
        return;
      let seeds = this.seeds;
      seeds.push(this.tmpSeed);
      this.$emit("seedUpdate", seeds);
      this.tmpSeed = '';
      document.getElementById('seed-input').focus();
    },
    
    removeSeed(seed) {
      let seeds = this.seeds;
      seeds.splice(this.seeds.indexOf(seed), 1);
      this.$emit("seedUpdate", this.seeds);
    },
  }
}
</script>
